import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { GlobalsService } from '../../../services/globals.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { UntypedFormControl } from '@angular/forms';

@Component({
	selector: 'app-gl-account-lookup',
	templateUrl: './gl-account-lookup.component.html',
	styleUrls: ['./gl-account-lookup.component.scss']
})
export class GlAccountLookupComponent implements OnInit, OnChanges {
	glaccounts: any = [];
	allglaccounts: any = [];
	glsearch = new UntypedFormControl('');
	/** In-dialog / no-overlay: filter input + scrollable list (no mat-autocomplete panel). */
	@Input() useInlineList = false;
	/** Visible label (Material outline label or inline field label). */
	@Input() label = 'General Ledger Account';
	readonly maxInlineResults = 300;
	filterText = new UntypedFormControl('');
	inlineList: any[] = [];

	@Input() preselected = false;
	@Input() reset = false;
	@Output() glselected = new EventEmitter<any>();
	constructor(private globalSearchService: GlobalSearchService, private globalsService: GlobalsService) {}

	ngOnInit(): void {
		this.globalsService.getGLAccounts().subscribe((result: any) => {
			const rows = Array.isArray(result) ? result : (result?.rows || []);
			this.allglaccounts = rows;
			this.glaccounts = rows;
			if (this.useInlineList) {
				this.applyInlineFilter(String(this.filterText.value || ''));
			}
		});

		if (this.useInlineList) {
			this.filterText.valueChanges.subscribe((q) => {
				this.applyInlineFilter(typeof q === 'string' ? q : '');
			});
		} else {
			this.glsearch.valueChanges.subscribe((newValue) => {
				const source = this.allglaccounts || [];
				if (newValue != '') {
					this.glaccounts = this.globalSearchService.filterItem([...source], newValue, 'accountcode,accountname');
				} else {
					this.glaccounts = source;
				}
			});
		}
	}

	applyInlineFilter(query: string): void {
		const source = this.allglaccounts || [];
		const q = (query || '').trim();
		let list: any[];
		if (q) {
			list = this.globalSearchService.filterItem([...source], q, 'accountcode,accountname');
		} else {
			list = source;
		}
		this.inlineList = list.slice(0, this.maxInlineResults);
	}

	addGl(value: any): void {
		this.glselected.emit(value);
	}

	selectInlineAccount(account: any): void {
		this.glselected.emit(account);
		this.filterText.setValue(this.displayFn(account), { emitEvent: false });
	}

	clearGl(): void {
		this.glsearch.setValue('');
		this.filterText.setValue('', { emitEvent: false });
		if (this.useInlineList) {
			this.applyInlineFilter('');
		}
	}

	displayFn(account: any) {

		if(!account) {
			return '';
		}

		return account.accountcode + '-' + account.accountname
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes?.reset?.currentValue) {
			this.clearGl();
		}

		const pre = this.preselected;
		if (pre == null || pre === false || !this.allglaccounts.length) {
			return;
		}

		const hasAccountCode = (x: unknown): x is { accountcode: string } =>
			typeof x === 'object' && x !== null && 'accountcode' in x;
		const value = hasAccountCode(pre)
			? pre
			: this.allglaccounts.find((r: any) => r.accountcode === pre);
		if (!value) {
			return;
		}
		if (this.useInlineList) {
			this.filterText.setValue(this.displayFn(value), { emitEvent: false });
		} else {
			this.glsearch.setValue(value);
		}
	}

}
